<template>
  <div
    class="column"
    :class="{ 'col full-height grow': embededPreview }"
  >
    <MentionPreview
      v-if="embededPreview"
      :body-class="bodyClass"
      class="preview no-shrink"
      :header="header"
      :mention="mention"
      :stream="stream"
      @close="close"
      @mention-removed="mentionRemoved"
    />
  </div>
</template>

<script>
import MentionPreview from "shared/components/streams/preview/MentionPreview.vue";
import {
  openExternalUrl,
  openExternalUrlForMention,
} from "shared/helpers/external";
import { mentionKeywords } from "shared/helpers/mentions";

export default {
  name: "MentionStreamMentionPreview",
  components: {
    MentionPreview,
  },
  props: {
    mention: {
      type: [Object, null],
      default: () => ({}),
    },
    header: {
      type: Boolean,
    },
    bodyClass: {
      type: [Array, Object, String],
      default: "",
    },
    embededPreview: {
      type: Boolean,
    },
    stream: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:embededPreview", "update:mention", "mention-removed"],
  computed: {
    keywords() {
      return mentionKeywords(this.mention);
    },
  },
  watch: {
    mention: {
      immediate: true,
      handler() {
        if (!this.mention) return;

        if (
          [
            "tweet",
            "facebook_post",
            "youtube_video",
            "instagram_post",
            "reddit_post",
            "reddit_post_comment",
            "blog_post",
            "forum_post",
            "podcast_episode",
          ].includes(this.mention.type)
        ) {
          openExternalUrlForMention(this.mention, this.$router);
          this.close();
        } else if (this.mention.type === "article") {
          this.openArticle();
        } else if (this.mention.type === "radio_clip") {
          this.close();
        } else if (
          ["paper_article", "magazine_article"].includes(this.mention.type)
        ) {
          // don't need the alert and privileges if viewing in admin mode
          if (this.$isAdminMode) {
            this.openPaperPreviewModal();
          } else {
            this.openViewMentionAlertModal();
          }
        } else {
          this.$emit("update:embededPreview", true);
        }
      },
    },
  },
  methods: {
    async openArticle() {
      if (this.mention.original_language === "English") {
        openExternalUrl(this.mention.url);
        this.close();

        return;
      }

      try {
        const mention = (
          await this.$streemApiV1.get(
            `${this.mention.type}s/${this.mention.id}`
          )
        ).data;

        if (!mention.body || this.$isAdminMode) {
          openExternalUrlForMention(mention, this.$router);
          this.close();

          return;
        }

        this.$modals.open("ViewMentionDetailModal", {
          props: {
            mention,
          },
        });

        this.close();
      } catch (error) {
        this.$error(
          this.$t("mention_stream_mention_preview.unable_to_load_media_item"),
          error
        );
      }
    },
    openViewMentionAlertModal() {
      this.$modals.open("ViewMentionAlertModal", {
        props: {
          mention: this.mention,
          keywords: this.keywords,
        },
        events: {
          continue: () => {
            this.openPaperPreviewModal();
            this.closeAlertModal();
          },
          cancel: () => this.cancelAlertModal(),
        },
      });
    },
    openPaperPreviewModal() {
      this.$modals.open("PaperPreviewModal", {
        props: {
          slot: "paper",
          mention: this.mention,
          keywords: this.keywords,
        },
        events: {
          close: () => this.closePreviewModal(),
        },
      });
    },
    close() {
      this.$emit("update:embededPreview", false);
      this.$emit("update:mention", null);
    },
    closeAlertModal() {
      this.$modals.close("ViewMentionAlertModal");
    },
    cancelAlertModal() {
      this.closeAlertModal();
      this.$emit("update:mention", null);
    },
    closePreviewModal() {
      this.$modals.close("PaperPreviewModal");
      this.closeAlertModal();
      this.$emit("update:mention", null);
    },
    mentionRemoved(mention) {
      this.$emit("mention-removed", mention);
      this.close();
    },
  },
};
</script>
